import { pageNames } from '@atc/bonnet-paths';

import { objectDuckCreator } from '@atc/modular-redux';

export default objectDuckCreator({
    namespace: pageNames.DEALER_DETAILS,
    store: 'metadata',
    storePrefix: `${pageNames.DEALER_DETAILS}.`,
    initialState: {
        title: '',
        description: '',
        canonical: '',
    },
});
